import React from 'react';
import { Section } from './ui/Section';
import { Gift, AlertOctagon } from 'lucide-react';
export function BonusSection() {
  return <Section className="bg-primary-dark text-cream rounded-3xl my-12 relative overflow-hidden" data-id="element-1">
      <div className="absolute top-0 right-0 w-64 h-64 bg-primary rounded-full blur-3xl opacity-50 -translate-y-1/2 translate-x-1/2" data-id="element-2"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-primary rounded-full blur-3xl opacity-50 translate-y-1/2 -translate-x-1/2" data-id="element-3"></div>

      <div className="relative z-10 max-w-4xl mx-auto" data-id="element-4">
        <div className="flex justify-center mb-6" data-id="element-5">
          <div className="bg-sage/20 p-4 rounded-full text-sage-light" data-id="element-6">
            <Gift size={40} data-id="element-7" />
          </div>
        </div>

        <h2 className="text-3xl md:text-5xl font-bold text-center mb-8" data-id="element-8">
          Bonus: Learn How to Choose Higher-Quality Supplements
        </h2>

        <div className="text-center mb-12" data-id="element-9">
          <p className="text-xl font-serif italic text-sage-light mb-4" data-id="element-10">
            One of the biggest mistakes people make is assuming that all
            supplements are created equal.
          </p>
          <p className="text-2xl font-bold text-white uppercase tracking-widest" data-id="element-11">
            They’re not.
          </p>
        </div>

        <div className="bg-black/20 backdrop-blur-md border border-white/10 p-8 rounded-2xl mb-10" data-id="element-12">
          <div className="flex items-center gap-3 mb-6 text-red-300" data-id="element-13">
            <AlertOctagon size={24} data-id="element-14" />
            <h3 className="text-xl font-semibold" data-id="element-15">
              Many products on the market contain:
            </h3>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-16">
            {['Cheap fillers', 'Unnecessary additives', 'Artificial dyes', 'Low-absorption forms', 'Unclear proprietary blends'].map((item, i) => <div key={i} className="bg-white/5 px-4 py-3 rounded-lg text-cream/90 text-center font-medium" data-id="element-17">
                {item}
              </div>)}
          </div>
        </div>

        <div className="text-center space-y-6 text-lg text-cream/90" data-id="element-18">
          <p data-id="element-19">
            That’s why this guide also includes{' '}
            <strong className="text-white" data-id="element-20">
              Bonus #2: How to Choose Quality Supplements
            </strong>
            , so you can make better decisions before your next purchase.
          </p>
          <p className="text-xl font-serif text-sage-light" data-id="element-21">
            You’ll learn what to look for in a supplement label — and what to
            avoid.
          </p>
        </div>
      </div>
    </Section>;
}